import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement } from "react";
import * as ReactDom from "react-dom";
import $style from "./index.scss";
export function modal(props) {
    document.body.style.overflowY = "hidden";
    function _close() {
        props.close();
        props.onCancel && props.onCancel();
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: $style.modal_ask
            }),
            /*#__PURE__*/ _jsx("div", {
                className: $style.modalWrap,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: $style.modal,
                    style: {
                        width: props.width
                    },
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            style: {
                                width: "0px",
                                height: " 0px",
                                overflow: "hidden",
                                outline: "none"
                            }
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: $style.content,
                            children: [
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: $style.close,
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: $style.closeX,
                                        onClick: _close,
                                        children: /*#__PURE__*/ _jsx("span", {
                                            role: "img",
                                            children: /*#__PURE__*/ _jsx("svg", {
                                                viewBox: "64 64 896 896",
                                                focusable: "false",
                                                "data-icon": "close",
                                                width: "1em",
                                                height: "1em",
                                                fill: "currentColor",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ _jsx("path", {
                                                    d: "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
                                                })
                                            })
                                        })
                                    })
                                }),
                                props.title ? /*#__PURE__*/ _jsx("div", {
                                    className: $style.header,
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: $style.title,
                                        children: props.title
                                    })
                                }) : null,
                                /*#__PURE__*/ _jsx("div", {
                                    className: $style.body,
                                    children: props.content
                                }),
                                props.showFooter ? /*#__PURE__*/ _jsxs("div", {
                                    className: $style.footer,
                                    children: [
                                        /*#__PURE__*/ _jsx("button", {
                                            type: "button",
                                            className: $style.btn,
                                            onClick: _close,
                                            children: /*#__PURE__*/ _jsx("span", {
                                                children: "取 消"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("button", {
                                            type: "button",
                                            className: `${$style.btn} ${$style.btnPrimary}`,
                                            onClick: props.onOk,
                                            children: /*#__PURE__*/ _jsx("span", {
                                                children: "确 定"
                                            })
                                        })
                                    ]
                                }) : null
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
const defaultOpen = {
    width: 500,
    okText: "确定",
    cancelText: "取消"
};
export function open(data) {
    let div = document.createElement("div");
    document.body.appendChild(div);
    const props = {
        ...defaultOpen,
        ...data
    };
    ReactDom.render(/*#__PURE__*/ createElement(modal, {
        ...props,
        close
    }), div);
    function close() {
        document.body.style.overflowY = "auto";
        if (div) {
            ReactDom.unmountComponentAtNode(div);
            document.body.removeChild(div);
            div = undefined;
        }
    }
    return close;
}
